// extracted by mini-css-extract-plugin
module.exports = {"list":"FieldRelations_list__2xUXp","expressionsActionsBtns":"FieldRelations_expressionsActionsBtns__374sW"};